import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BrandingConfigurationService } from "@ptl/brand";
import { HTTPWrapperContext, NormalizedResponse, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from "@ptl/xhr";
import { SmallGroupSBCByGroupNumberResponse } from "../interfaces/search-by-group-number.interface";
import { SmallGroupSbcRequest } from "../interfaces/SmallGroupSbcRequest.interface";
import { SmallGroupSBCItem } from "../interfaces/SmallGroupSbcResponse.interface";

@Injectable({
    providedIn: 'root'
})
export class SmallGroupSbcService {

    constructor(
        private httpClient: HTTPWrapperContext,
        private brandService: BrandingConfigurationService
    ) { }

    async getSmallGroupSbcs(payload: SmallGroupSbcRequest): Promise<SmallGroupSBCItem[]> {

        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: '/cmcrst/x-services/public/smallgroup',
            POST_OR_PUT_PAYLOAD: payload
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        return this.httpClient.makeRequest<SmallGroupSBCItem[]>(requestConfig);
    }

    
    async groupNumberSearch(payload: unknown): Promise<NormalizedResponse<SmallGroupSBCByGroupNumberResponse>> {

        const requestConfigImplementation = new RequestConfigImplementation({
            url: "/cmcrst/x-services/sbc/documents",
            method: REQUEST_METHODS.POST,
            headers: new HttpHeaders({
                ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
            }),
            POST_OR_PUT_PAYLOAD: payload,
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        return this.httpClient.makeRequest(requestConfigImplementation);
    }

    openSbc(sbc: SmallGroupSBCItem, isIndv) {
        if (isIndv) {
            window.open(sbc.link);
        } else {
            if (sbc.hasNonErisaSbcDoc) {
                window.open(
                    `https://${window.location.host}/cmcrst/x-services/sbc/file/${sbc.NonErisaSbcDoc.fileName}`,
                    '_blank'
                );
            } else {
                window.open(
                    `https://${window.location.host}/cmcrst/x-services/sbc/file/${sbc.ErisaSbcDoc.fileName}`,
                    '_blank'
                );
            }

        }
    };

}